module.exports = __webpack_public_path__ + "media/images/shark/Naranjo_9201-p-1080-ed4b5a4f0d11b1eab5f32347bf44fbcb.jpeg";